import throttle from '@/utils/throttle'

export default {
  data() {
    return {
      cachedWindowInnerWidth: window.innerWidth
    }
  },
  mounted() {
    this.__handleWindowResize = throttle(this.__handleWindowResize, 500)
    window.addEventListener('resize', this.__handleWindowResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.__handleWindowResize)
  },
  methods: {
    __handleWindowResize() {
      const innerWidth = window.innerWidth

      // Bail if width didn't change
      if (this.cachedWindowInnerWidth === innerWidth) {
        return
      }
      this.cachedWindowInnerWidth = innerWidth
      if (typeof this.onWindowHorizontalResize === 'function') {
        this.onWindowHorizontalResize(innerWidth, window.innerHeight)
      }
    }
  }
}
